<template>
  <div>
    <md-field>
      <label>{{ label }}</label>
      <md-input ref="input" :value="value" @input="$emit('update:value', $event)" type="text" :required="required"></md-input>
    </md-field>
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
import 'flatpickr/dist/themes/material_blue.css'

export default {
  props: {
    /**
     * PlaceHolder
     */
    label: {
      type: String,
    },
    /**
     * 入力必須か
     */
    required: {
      type: Boolean,
    },
    /**
     * 選択されている日付
     */
    value: {
      type: String,
      validator(value) {
        const regex = new RegExp(/^\d{4}-\d{2}-\d{2}$/g)
        return regex.test(value)
      },
    },
  },
  data() {
    return {
      picker: undefined,
    }
  },
  watch: {
    value(date) {
      this.picker.setDate(date)
    },
  },
  mounted() {
    this.picker = flatpickr(this.$refs.input.$el, {
      locale: Japanese,
      altFormat: 'Y年n月j日',
      altInput: true,
      dateFormat: 'Y-m-d',
      defaultDate: this.value,
    })
    this.$on('hook:beforeDestroy', () => this.picker.destroy())
  },
}
</script>
